// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nlabel[data-v-06e23a01] {\n    font-weight: 500;\n}\n.g-3>.col-md-3[data-v-06e23a01] {\n    display: flex;\n    flex-direction: column;\n}\n", ""]);
// Exports
module.exports = exports;
